module.exports = __webpack_public_path__ + "static/media/Icona-3.fa0a66dd.svg";